/* eslint-disable */
export default {
  header: 'サポートへのお問い合わせ',
  toggleTitle: '1. エラー追跡モードを有効化する',
  toggleDescription:
    'これは問題の特定に役立ちますが、アプリのパフォーマンスに若干の影響が出る可能性があります。',
  downloadTitle: '2. 問題を複製したら、エラーログをダウンロードする',
  downloadButton: 'ダウンロード',
  downloadDisabledTitle:
    'エラー追跡モードを有効化すると、エラーログをダウンロードできるようになります。',
  sendTitle: '3. ログをサポートチームに送信する',
  createSupportTicket: 'サポートチケットを作成し、',
  sendDescription:
    ' サポートチームにお問い合わせください。次に、トラブルシューティングのためにログをサポートチームに送信します。',
  privacyNotice:
    'ダウンロードしてログを送信することで、RingCentralがトラブルシューティングとエラー対処を目的としてログに関係する特定の情報にアクセスすることに同意したものとみなされます。RingCentralによる個人データの処理方法の詳細については、 ',
  privacyNoticeLink: '利用規約',
  and: ' および ',
  privacyNoticeEnd: 'プライバシーに関する通知を確認してください。',
  needLeavePage:
    'エラー追跡の実行中に、このページから移動することもできます。問題を複製したら、このページに戻り、ログファイルをダウンロードします。',
  downloading: 'ダウンロード中',
} as const;

// @key: @#@"header"@#@ @source: @#@"Contact support"@#@
// @key: @#@"toggleTitle"@#@ @source: @#@"1. Turn on error tracking mode"@#@
// @key: @#@"toggleDescription"@#@ @source: @#@"This will help us locate your issues, but may slightly affect your app performance."@#@
// @key: @#@"downloadTitle"@#@ @source: @#@"2. Download the error log when you have replicated the issue."@#@
// @key: @#@"downloadButton"@#@ @source: @#@"Download"@#@
// @key: @#@"downloadDisabledTitle"@#@ @source: @#@"Turn on error tracking mode before you can download error log."@#@
// @key: @#@"sendTitle"@#@ @source: @#@"3. Send the log to support team"@#@
// @key: @#@"createSupportTicket"@#@ @source: @#@"Create a support ticket"@#@
// @key: @#@"sendDescription"@#@ @source: @#@" to get in touch with our support team. Then send the log to the support team for troubleshooting."@#@
// @key: @#@"privacyNotice"@#@ @source: @#@"By downloading and sending us the log, you agree to allow RingCentral to access certain log related information for troubleshooting and error handling purposes. For more information on how RingCentral processes personal data, please review our "@#@
// @key: @#@"privacyNoticeLink"@#@ @source: @#@"Terms of Service"@#@
// @key: @#@"and"@#@ @source: @#@" and "@#@
// @key: @#@"privacyNoticeEnd"@#@ @source: @#@"Privacy Notice."@#@
// @key: @#@"needLeavePage"@#@ @source: @#@"You may leave this page while error tracking is running. When you have replicated the issue, return to this page and download the log files."@#@
// @key: @#@"downloading"@#@ @source: @#@"Downloading"@#@
